import { useEffect } from 'react';

/**
 * Dynamically injects JSON-LD article schemas into the DOM so that 
 * when search engines or AI bots execute the JS, they immediately
 * understand the structured content of the articles being displayed.
 */
const SEOHead = ({ activeCategory, articles }) => {
  useEffect(() => {
    // 1. Dynamically update the page title for standard SEO
    document.title = activeCategory.id === 'All' 
      ? 'Sulit.ph Magazine | Latest Stories' 
      : `${activeCategory.label} | Sulit.ph Magazine`;

    // 2. Inject dynamic JSON-LD structured data for AI / Rich Snippets
    if (!articles || articles.length === 0) return;

    let script = document.getElementById('dynamic-json-ld');
    if (!script) {
      script = document.createElement('script');
      script.id = 'dynamic-json-ld';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    // Create an ItemList schema representing the feed
    const schema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": `Sulit.ph - ${activeCategory.label} Articles`,
      "itemListElement": articles.slice(0, 10).map((article, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Article",
          "headline": article.title,
          "url": article.link,
          "description": article.summary,
          "datePublished": article.pubDate ? new Date(article.pubDate).toISOString() : new Date().toISOString(),
          "author": {
            "@type": "Person",
            "name": article.author || "Sulit.ph"
          }
        }
      }))
    };

    script.textContent = JSON.stringify(schema);

  }, [activeCategory, articles]);

  return null; // This component doesn't render any UI
};

export default SEOHead;